import React from "react";
import classNames from "classnames";

import { ChevronLeftOutlined, InformationFilled } from "@toddle-edu/ds-icons";
import {FormTextInput} from "UIComponents/InputTextField";
import { Trans } from "react-i18next";

import classes from "./Step2.scss";

const Step2 = props => {
  const { onBackClick, data, updateInputField } = props;
  const {
    firstName,
    lastName,
    visitorsOrganizationName,
    contact,
    invitedBy = "Toddle Support",
    orgName = "Toddle",
  } = data;

  return (
    <div className={classes.step2Container}>
      <div
        onClick={onBackClick}
        className={classNames("text-label-2", classes.goBackContainer)}
      >
        <ChevronLeftOutlined size="xxx-small" variant="success" />
        {"Go back"}
      </div>

      <div className={classNames(classes.infoBanner)}>
        <div>
          <InformationFilled size="x-small" variant="link" />
        </div>
        <div className={classNames("text-body-1", classes.infoBannerText)}>
          <Trans i18nKey="project:cas_external_signup_details_banner">
            {{ invitedBy }}
            <strong>invitedBy</strong>
            <strong>orgName</strong>
            {{ orgName }}
            You may change them if needed.
          </Trans>
        </div>
      </div>

      <div className={classes.inputsContainer}>
        <div className={classes.nameContainer}>
          <div>
            <FormTextInput
              textInputLabel={"First name"}
              value={firstName}
              name={"firstName"}
              placeholder={"Enter first name"}
              updateInputField={updateInputField}
              size={"large"}
              isRequired={true}
            />
          </div>
          <div>
            <FormTextInput
              textInputLabel={"Last name"}
              value={lastName}
              name={"lastName"}
              placeholder={"Enter last name"}
              updateInputField={updateInputField}
              size={"large"}
              isRequired={true}
            />
          </div>
        </div>
        <div className={classes.inputContainer}>
          <FormTextInput
            textInputLabel={"Organization"}
            value={visitorsOrganizationName}
            name={"visitorsOrganizationName"}
            placeholder={"Enter organization name"}
            updateInputField={updateInputField}
            size={"large"}
            isRequired={true}
          />
        </div>
        <div className={classes.inputContainer}>
          <FormTextInput
            textInputLabel={"Contact number"}
            value={contact}
            name={"contact"}
            placeholder={"Enter Contact number"}
            updateInputField={updateInputField}
            size={"large"}
          />
        </div>
      </div>
    </div>
  );
};

export default Step2;
